import script from "./TimetableSearchInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimetableSearchInput.vue?vue&type=script&setup=true&lang=ts"

import "./TimetableSearchInput.vue?vue&type=style&index=0&id=4f878102&lang=scss"

const __exports__ = script;

export default __exports__